module.exports = __webpack_public_path__ + "media/img/astronauto-green-f4ecb4ba.png";